import { useState } from "react";
import { getApi, postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";
import { toast } from "react-hot-toast";
import { Country, State,City } from "country-state-city";
function useLoadMasterData(childIndex,navigate) {
  const [masterData, setMasterData] = useState({
    languageData: null,
    nakshatraData: null,
    rashiData: null,
  });
  const [childnakshatra, setchildNakshatra] = useState([]);
  const [childrenrashi, setChildrenRashi] = useState([]);
  const [spousechildnakshatra, setspouseNakshatra] = useState();
  const [spouserashi, setSpouseRashi] = useState();
  const [countryList,setCountryList] = useState([]);
  const [stateList,setStateList] = useState([]);
  const [cityList,setCityList] = useState([]);

  const getMasterData = async () => {
    const payload = {
      country_id: "611ce96de2cd656171314e2a",
      rashi_id: "611ce9cde2cd656171314e4f",
      rashi_id: "611cec0ee2cd656171314edf",
    };
    const result = await Promise.all([
      getApi(apiEndPoints.languages),
      getApi(apiEndPoints.nakshatram),
      getApi(apiEndPoints.rashi),
    ]);

    setchildNakshatra((prev) => {
      const updatedChildrenNakshatra = [...prev];
      updatedChildrenNakshatra[childIndex] = result[1]?.data?.data;
      return updatedChildrenNakshatra;
    });
    setChildrenRashi((prev) => {
      const updatedChildrenRashi = [...prev];
      updatedChildrenRashi[childIndex] = result[3]?.data?.data;
      return updatedChildrenRashi;
    });

    setspouseNakshatra((childnakshatra[0] = result[1]?.data?.data));
    setSpouseRashi(result[2]?.data?.data);
    setMasterData({
      languageData: result[0]?.data?.data,
      nakshatraData: result[1]?.data?.data,
      rashiData: result[2]?.data?.data,
    });
  };

  const getCountryData = ()=>{
    const countries = Country.getAllCountries();
    setCountryList(countries);
  }

  const handleCountryChange = (countryCode) => {
    const states = State.getStatesOfCountry(countryCode);
    setStateList(states);
    setCityList([]);
  };
  
  const handleStateChange = (stateCode, countryCode) => {
    const cities = City.getCitiesOfState(countryCode, stateCode);
    setCityList(cities);
  };

  const onSubmit = async (data) => {
    try {
      const response = await postApi(apiEndPoints.devoteeRegister, data);
      if (response?.data?.status === 0) {
        toast.error(response?.data?.message);
      } else if (response?.data?.status === 1) {
        toast.success(response?.data?.message);
        localStorage.setItem(
          "devoteeData",
          JSON.stringify(response?.data?.data)
        );
        navigate("/registrationsuccess");
      } else {
        toast.error("Something Went Wrong");
      }
    } catch (error) {
      toast.error(`Registration failed: , ${error}`);
    }
  };

  return {
    masterData,
    setMasterData,
    childnakshatra,
    setchildNakshatra,
    childrenrashi,
    setChildrenRashi,
    spouserashi,
    setSpouseRashi,
    spousechildnakshatra,
    setspouseNakshatra,
    getMasterData,
    onSubmit,
    getCountryData,
    countryList,
    stateList,
    cityList,
    handleCountryChange,
    handleStateChange
  };
}

export default useLoadMasterData;
